import React, { useEffect } from 'react';
import {
  DualListComponent,
  ActionsComponent,
  ViewComponent,
} from './components';
import { CloseButton, Container, CustomModal, LoaderContainer } from './styles';
import { Modal } from 'react-bootstrap';
import { useImpressao } from './ImpressaoContext';
import { AiOutlineClose } from 'react-icons/ai';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { CircularProgress } from '@material-ui/core';
import { EditableModalTitle } from './components/EditableModalTitle';

interface IImpressao {
  show: boolean;
  codTela: number;
  handleShow: (show: boolean) => void;
  filters: any;
}

const MySwal = withReactContent(Swal);

const Impressao: React.FC<IImpressao> = ({
  show,
  codTela,
  handleShow,
  filters,
}: IImpressao) => {
  const {
    handleCodTela,
    handleFilters,
    isChangeView,
    handleSaveView,
    isLoading,
    selectedOption,
  } = useImpressao();

  useEffect(() => {
    handleFilters(filters);
  }, [filters, handleFilters]);

  useEffect(() => {
    handleCodTela(codTela);
  }, [codTela, handleCodTela]);

  const handleCloseModal = () => {
    if (isChangeView) {
      MySwal.fire({
        title: '',
        text: 'Há alterações pendentes. Deseja salvá-las antes de continuar?',
        showCancelButton: true,
        confirmButtonText: 'Salvar Alterações',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#0065FF',
        cancelButtonColor: '#DE350B',
        allowOutsideClick: false,
        icon: 'warning',
      }).then(async (result) => {
        if (result.isConfirmed) {
          await handleSaveView();
          return handleShow(false);
        }
        return handleShow(false);
      });
    } else {
      handleShow(false);
    }
  };

  return (
    <CustomModal
      size="xl"
      show={show}
      onHide={handleCloseModal}
      centered
      animation
    >
      <Modal.Header
        style={{
          paddingBottom: '0.5rem',
        }}
      >
        {!selectedOption && <Modal.Title>Impressão/Relatório</Modal.Title>}
        {selectedOption && <EditableModalTitle />}
        <CloseButton onClick={handleCloseModal}>
          <AiOutlineClose size={24} />
        </CloseButton>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <LoaderContainer>
            <CircularProgress size={36} style={{ color: '#57069E' }} />
          </LoaderContainer>
        ) : (
          <Container>
            <ViewComponent />
            <DualListComponent componentRole="impressao" />
            <ActionsComponent />
          </Container>
        )}
      </Modal.Body>
    </CustomModal>
  );
};

export default Impressao;
